module.exports = __webpack_public_path__ + "img/carmen-melean.e2176480.jpg";